import { render, staticRenderFns } from "./homepageRadio.vue?vue&type=template&id=06f7532a&scoped=true&"
import script from "./homepageRadio.vue?vue&type=script&lang=js&"
export * from "./homepageRadio.vue?vue&type=script&lang=js&"
import style0 from "./homepageRadio.vue?vue&type=style&index=0&lang=css&"
import style1 from "./homepageRadio.vue?vue&type=style&index=1&id=06f7532a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f7532a",
  null
  
)

export default component.exports